import styled from 'styled-components';

export const StateList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const StateItem = styled.li`
  font-size: 20px;
  font-weight: 500;
  span {
    font-weight: 400;
  }
`;
